import memoize from 'fast-memoize';
import styled from 'styled-components';
import { CardProps } from '@components/types';
import Text from '@components/Text/Text';

const getBorder = memoize((theme: any, borderColor: string, colorWeight: number) => {
    const color = colorWeight ? theme?.colors?.[borderColor]?.[colorWeight] : theme?.colors?.[borderColor];
    return `9px solid ${color}`;
});

export const Card = styled.div<CardProps>`
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    border: 1px solid rgba(13, 42, 67, 0.18);
    border-radius: 4px;
    background-color: ${({ theme }) => theme?.colors?.white};
    border-left: ${({ theme, borderColor, colorWeight }) => getBorder(theme, borderColor, colorWeight)};
    min-height: 162px;
    padding: 15px;
    flex: 1;
    box-shadow: 5px 7px 6px 0 rgba(0, 0, 0, 0.08);
`;

export const CardHeader = styled.div`
    display: flex;
    min-width: max-content;
    margin-bottom: 10px;
    align-items: center;
`;

export const CardText = styled(Text)`
    color: #656565;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 14px;
    margin-left: 58px;
`;

export const LinkWrapper = styled.div`
    margin-top: 15px;
    align-self: flex-end;
    @media screen and (max-width: 1200px) {
        margin-top: 15px;
    }
`;

export const CardLinkText = styled.div`
    font-size: 18px;
    a {
        text-decoration: none;
        font-weight: 500;
        cursor: pointer;
        margin-right: 12px;
    }
`;

export const CardContentWrapper = styled.div`
    display: flex;
    align-items: baseline;
`;

export const CardContent = styled.div`
    color: #656565;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 14px;
    margin-top: 18px;
`;
